import { JobConfiguration } from '../job-configuration';
import { JobConfigRegistry } from '../index';
import config from './config';

export default new Proxy(new Map(Object.entries(config)), {
    get: function(target, type: string): JobConfiguration {
        if (!target.has(type))
            throw new Error(`Unknown Job Type: "${type}"`);
        return Reflect.construct(target.get(type), []);
    }
}) as unknown as JobConfigRegistry;
